"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_2 = require("@heroui/react");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const Sidebar = ({ logo, currentRoute, topMenuItems, onMenuItemClick }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const handleItemClick = (item) => {
        if (onMenuItemClick) {
            onMenuItemClick(item);
        }
        else {
            navigate(item.route);
        }
    };
    const isActive = (route) => {
        return currentRoute === route || currentRoute.startsWith(route);
    };
    const getLogoSize = () => {
        switch (logo.size) {
            case "small":
                return "h-8";
            case "large":
                return "h-16";
            case "medium":
            default:
                return "h-12";
        }
    };
    // Memoize selectedKeys to prevent unnecessary re-renders
    const selectedKeys = react_1.default.useMemo(() => [currentRoute], [currentRoute]);
    return (react_1.default.createElement("div", { className: "flex flex-col h-full bg-white shadow-lg w-60" },
        react_1.default.createElement("div", { className: "flex items-center justify-center px-4 py-6 border-b border-borders" },
            react_1.default.createElement("img", { src: logo.image, alt: "Logo", className: `${getLogoSize()} object-contain` })),
        react_1.default.createElement("div", { className: "flex-1 py-4 overflow-y-auto" },
            react_1.default.createElement(react_2.Listbox, { "aria-label": "Navigation menu", variant: "flat", selectionMode: "single", selectedKeys: selectedKeys, className: "gap-1 px-2" }, topMenuItems.map((item) => (react_1.default.createElement(react_2.ListboxItem, { key: item.route, textValue: item.label, color: "primary", className: `
                mb-1 rounded-lg transition-colors duration-200
                data-[hover=true]:bg-orange data-[hover=true]:text-white
                ${isActive(item.route) ? "bg-primary text-white" : "text-black"}
              `, onClick: () => handleItemClick(item), startContent: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: item.icon, className: `text-lg transition-colors ${isActive(item.route) ? "text-white" : "text-black"} group-data-[hover=true]:text-white` }), endContent: item.count && item.count > 0 ? react_1.default.createElement(react_2.Chip, { className: "p-0 font-semibold text-white bg-orange" }, item.count) : null },
                react_1.default.createElement("span", { className: `font-medium transition-colors ${isActive(item.route) ? "text-white" : "text-black"}` }, item.label))))))));
};
exports.Sidebar = Sidebar;
